<template>
        <header class=" fixed-top app-header-inter-pages dash-header page-container">
            <div class="container-fluid py-12  border-bottom px-0">
                <div>
                    <NuxtLayout name="header" />

                </div>
                
            </div>
            
            <div class="bg-white bottom-header" v-if="width >= breakpoints.screen_tablet">
                <div class=" container-xl d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start p-12">
    
                    <ul class="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0 gap-3">
                        <li v-for="link in links">
                            <nuxt-link :to="link.url" class="nav-link px-3 d-flex align-items-center">
                                <span class="material-symbols-rounded d-flex align-items-center fsz-20 me-1">{{ link.icon }}</span>
                                {{ link.label }}
                            </nuxt-link>
                        </li>

                        <li>
                            <div class="dropdown-container position-relative d-inline" >
                                                        



                                <OnClickOutside @trigger=" dropdown = false"  v-if="dropdown" class="dropdown-inner dropdowns-panel "  >
                        
                              
                                    <ul class="inner-list">
                                        <li   >
                
                                            <nuxt-link @click="dropdown = false" class=" options " to="/dashboard/savedsearches">
                                                
                
                                                Recherches sauvegardées
                                            </nuxt-link>
                
                                        </li>
                                        <li   >
                
                                            <nuxt-link @click="dropdown = false" class=" options " to="/dashboard/saveditems">
                                                
                
                                                Annonces sauvegardées
                                            </nuxt-link>
                
                                        </li>
                                    </ul>
                               
                           
                
                            </OnClickOutside>
                            <!-- ui purpose -->
                            <ul class="inner-list dropdown-container  d-none">
                                <li   >
        
                                    <nuxt-link class=" options " to="/dashboard/savedsearches">
                                        
        
                                        Recherches sauvegardées
                                    </nuxt-link>
        
                                </li>
                                <li   >
        
                                    <nuxt-link class=" options " to="/dashboard/saveditems">
                                        
        
                                        Annonces sauvegardées
                                    </nuxt-link>
        
                                </li>
                            </ul>
                            <a    @click.stop="  dropdown = !dropdown  " class="nav-link px-2 cursor-pointer d-flex align-items-center" >
                                  
                                <span class="material-symbols-rounded d-flex align-items-center fsz-20 me-1">{{ icons.heart }}</span>
                                Sauvegardes 
                                <i class="material-symbols-rounded fsz-20">expand_more</i>
                            </a>
                            </div>
                        </li>

                    </ul>
                    <div v-if="dashStore.getUserProfil.isPro">
                        <nuxt-link v-if="dashStore.getUserProfil.marketplaces && dashStore.getUserProfil.marketplaces.length"
                        class="btn xsmaller-btn btn-outline-primary-600 d-flex align-items-center" 
                        to="/marketplace/builder">
                            <span class="material-symbols-rounded d-flex align-items-center fsz-20 me-1">{{ icons.store }}</span>
                            Modifier votre espace pro
                        </nuxt-link>
                        <!-- <nuxt-link v-else  class="btn btn-outline-primary-600" to="/marketplace/creation">
                            <component :is="icons.store" class="d-20"></component>
                            Créer votre espace pro
                        </nuxt-link> -->
                    </div>
                 <div v-else>
                    <nuxt-link class="btn btn-outline-primary-600 d-flex align-items-center"
                    to="/marketplace/creation">
                        <span class="material-symbols-rounded d-flex align-items-center fsz-20 me-1">{{ icons.store }}</span>
                        Créer votre espace pro
                    </nuxt-link>
                 </div>
               
                </div>
            </div>
            

        </header>

        <nav class=" px-3 sticky-toolbar bg-white py-12 border-top" v-if="width< breakpoints.screen_tablet" >
            <nuxt-link class="btn xsmaller-btn btn-solid-primary-600 fsz-14 w-100 d-flex align-items-center justify-content-center"
                @click="handleAddAnnounce"
                >
                <span class="material-symbols-rounded d-flex align-items-center fsz-20 me-1">{{ icons.plus }}</span>
                    Ajouter une annonce
            </nuxt-link>
        </nav>
        <main class=" container-fluid pt-32 bg-gray-100 dash-body page-container px-3 pb-40"  v-bind:style="{ minHeight: `calc(100vh - 127px - ${footerHeight}px)`  }">
            <div class="main-content container-xl w-100 px-0 px-lg-2">
            <slot />
        </div>
        </main>
       <div ref="footerContainer">
       <NuxtLayout :name="layout"></NuxtLayout>

       </div>
       <UiElementContactEmbed/>

</template>
  
<script setup>
import { trackAnnouncementStarted } from '~/composables/useFirebaseAnalytics'
import { breakpoints } from '~/utils/breakpoints.js'
import { useResizeObserver } from '@vueuse/core'
import { OnClickOutside } from '@vueuse/components'

const { renderWidth: width } = useDeviceWidth();

const dashStore = useDashboardStore();
const { sendAddAnnouncementTelegram } = useAddAnnouncementTelegram();

const { isConnected } = defineProps(['isConnected'])
const dropdown = ref(false)
const layout = ref('footer')
const footerContainer= ref('')
const footerHeight = ref();

const icons = reactive({
    bell: 'notifications',
    plus: 'add',
    messege: 'mail',
    currency: 'paid',
    car: 'directions_car',
    home: 'home',
    store: 'storefront',
    heart: 'favorite',
    cog: 'settings'
});

const handleAddAnnounce = () => {
  if (dashStore.getUserProfil.id) {
    void sendAddAnnouncementTelegram('manuel')
    trackAnnouncementStarted({ announce_type_created: 'Manuel' })
    navigateTo('/listing-form/vehicle-data?fresh=true')
  } else {
    navigateTo('authentication/signup')
  }
}

const links = ref([

    {
        label: 'Tableau de bord',
        class: '',
        url: '/dashboard/home',
        icon : icons.home
    },
    {
        label: 'Mes annonces',
        class: '',
        url: '/dashboard/items',
        icon : icons.car

    },
    {
        label: 'Mes offres',
        class: 'border-bottom',
        url: '/dashboard/offers',
        icon : icons.currency
    },
    {
        label: 'Messages',
        class: 'border-bottom',
        url: '/dashboard/inbox',
        icon : icons.messege
    }
   

]);
useResizeObserver(footerContainer, (entries) => {
  const [entry] = entries
  const { width, height } = entry.contentRect
  footerHeight.value = height
})

const activeFooter = () => {
    const { path } = useRoute()
    if (path == '/dashboard/inbox') {
        layout.value = ''
        return
    }
    layout.value ='footer'
}
onMounted(() => {
    activeFooter()
})
onUpdated(() => {
    activeFooter()
    
});
</script>
<style lang="scss" scoped>
@import '../assets/styles/mixins';

.dropdown-inner {
    background-color: white;
    position: absolute;
    right: 0 !important;
    top: 45px;
    z-index: 1030;
    border-radius: 8px;
    box-shadow: 2px 2px 5px rgba(10, 10, 10, 0.1);
}
.dropdowns-panel{
    min-width: 210px;
}

.logoContainer{
    position: absolute;
    left: 40%;
}

.dash-body{
    margin-top: 50px;
    @include screen-tablet-above {
        margin-top: 130px;
    }
}


</style>
  
